import { Style } from "../../style.js";
/**
 * {@link https://html.spec.whatwg.org/#inert}
 *
 * @public
 */
export function isInert(device) {
    return Style.hasComputedStyle("visibility", (specified) => specified.value === "hidden" || specified.value === "collapse", device);
}
//# sourceMappingURL=is-inert.js.map